uniform float uTime;
uniform float uAudioLevel;

varying vec2 vUv;
varying vec3 vNormal;
varying float vDisplacement;

void main() {
  vUv = uv;
  vNormal = normal;

  vec3 pos = position;

  float wave1 = sin(pos.x * 4.0 + uTime * 1.0);
  float wave2 = cos(pos.y * 6.0 + uTime * 1.5);
  float wave3 = sin(pos.z * 3.0 - uTime * 3.0);

  float displacement = (wave1 + wave2 + wave3) * 0.5 * (1.0 + uAudioLevel * 5.0);
  vDisplacement = displacement;

  pos += normal * displacement * 0.2;

  pos.z += sin(uTime + length(pos.xy) * 2.0) * uAudioLevel * 2.0;

  gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
}
